import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccessService, StubAccessService } from '../access';

@Injectable({ providedIn: 'root' })
export class AccessViewGuard implements CanActivate {
  constructor(
    @Inject(StubAccessService) private access: AccessService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const view = route.data.view;
    return this.access.hasAccessToViews([view]).pipe(
      map((access) => {
        const hasAccess = access.get(view);
        if (hasAccess) {
          return true;
        }
        return this.router.createUrlTree(['/access-denied'], { queryParams: { page: state.url } });
      }),
    );
  }
}
